export default "__VITE_ASSET__5686c875__"